import { useEffect } from "react";
import useAttachment from "../../hooks/useAttachment";
import useAudioRecording from "../../hooks/useAudioRecording";
import HToolTip from "../custom/info/HToolTip";

const MAX_RECORDING_TIME = 600; // 10 minutes

function VoiceRecordingButton({ appProperties, fileList, handleMediaFileList, integrationId, contactId }) {
  const { isRecording, recordingTime, startRecording, stopRecording, formatRecordingTime, isRecordingLoading } = useAudioRecording(true);

  const { uploadAttachment } = useAttachment(appProperties, fileList, handleMediaFileList, false);

  const handleStopRecording = async () => {
    if (isRecording) {
      const audioFile = await stopRecording();
      if (audioFile && uploadAttachment) {
        await uploadAttachment(audioFile, null, null, null, null, integrationId, null, contactId);
      }
    }
  };

  useEffect(() => {
    if (recordingTime >= MAX_RECORDING_TIME) {
      handleStopRecording();
    }
  }, [recordingTime]);

  return (
    <HToolTip title={isRecording ? "(Recording)" : "Voice message"}>
      <div
        className={`hs-border-8 d-flex align-items-center justify-content-between recording-button-container${isRecording ? " recording" : ""}`}
      >
        {isRecordingLoading ? (
          <div className="actionIconsSprite search-loading"></div>
        ) : (
          <div
            className={`actionIconsSprite voice-record-icon${isRecording ? " recording" : ""}`}
            onClick={isRecording ? handleStopRecording : startRecording}
          />
        )}
        {isRecording && <div className="my-auto hs-color-dark-grey-2 hs-fw-500">{formatRecordingTime(recordingTime)}</div>}
      </div>
    </HToolTip>
  );
}

export default VoiceRecordingButton;
